import styled from 'styled-components';
import { FluidObject } from 'gatsby-image';
import GatsbyImage from 'gatsby-image/withIEPolyfill';
import {
  daveGrey,
  jetBlack,
  mercuryGrey,
} from '@shipae/components-sandbox/component/colors';
import { fonts, media } from 'src/views/theme';
import SmartLink from '../smart-link';

interface CardImageProps {
  fluid: FluidObject | FluidObject[];
}

const cardRightMargin = 3;

const theme = {
  Main: styled(SmartLink)`
  display: block;
  width: calc((100% - ${ cardRightMargin * 2 }rem) / 2);
  ${ media.md } {
    width: auto;
  }

  border: 1px solid ${ mercuryGrey() };
  border-radius: 8px;
  margin: 0 ${ cardRightMargin }rem 4.9rem 0;

  ${ media.sm } {
    margin-right: 0;
  }

  &, &:visited, &:active {
    text-decoration: none;
  }
  `,
  CardImage: styled(GatsbyImage)<CardImageProps>`
  width: 100%;
  height: 30rem;
  border-radius: 8px 8px 0 0;

  ${ media.sm } {
    height: 40rem;
  }
  `,
  Text: styled.div`
  padding: 2rem;
  border-radius: 0 0 8px 8px;
  `,
  Date: styled.span`
  display: block;
  color: ${ daveGrey() };
  text-transform: uppercase;
  ${ fonts.bodys300 };
  margin-bottom: 0.5rem;
  `,
  Title: styled.h2`
  ${ fonts.displayxs300 };
  color: ${ jetBlack() };
  line-height: 3.3rem;
  margin-bottom: 1rem;
  min-height: 6rem;
  `,
  Description: styled.p`
  color: ${ daveGrey() };
  ${ fonts.bodyl100 };
  `,
};

export default theme;
